var $class="se2--content-article-slide-carousel-background",$name="ContentArticleSlideCarouselBackground",$path="app/components/ContentArticleSlideCarouselBackground/index.js",$this={$class,$name,$path,};import lazyHandleOpenModalButtons from 'app/components/utilities/lazyHandleOpenModalButtons';

import shell from 'app/modules/shell';

import 'app/partials/image';
import 'app/partials/roiCalculatorWidget';

import initializeSlider from 'app/components/utilities/initializeSlider';

import setYoutubeVideoThumbnail from 'app/utilities/setYoutubeVideoThumbnail';

import { css } from 'configs';

import {
  slidesSelector,
  prevButtonSelector,
  nextButtonSelector,
  articleSlideContainerSelector,
  paginationBulletClassName,
} from './config';

import contentArticleSlideCarouselBackgroundSlideSelector from './partials/slide';

export default shell.registerComponent($this, ({ addEventListener, mount }) => {
  mount((element) => {
    const amountOfSlides = element.querySelectorAll(contentArticleSlideCarouselBackgroundSlideSelector).length;
    if (amountOfSlides > 1) {
      let currentSlider = null;

      currentSlider = initializeSlider(element, addEventListener, {
        containerSelector: slidesSelector,
        isArticleSlides: true,
        nextButtonSelector,
        paginationBulletSelector: `.${paginationBulletClassName}`,
        prevButtonSelector,
        preventKeyNavigation: true,
        slideSelector: contentArticleSlideCarouselBackgroundSlideSelector,
        swiperContainerSelector: articleSlideContainerSelector,
        withInteractiveElements: true,
      });

      addEventListener(window, 'resize', currentSlider.onResize);
    }

    const { videoThumbnail, videoPlayButton } = css.classNames;
    setYoutubeVideoThumbnail(element, videoThumbnail);
    lazyHandleOpenModalButtons(addEventListener, element, [videoThumbnail, videoPlayButton]);
  });
});
